// Centralized API configuration
// ALWAYS use current origin to prevent CORS issues with custom domains
import axios from 'axios';

// Force axios to NOT use any externally-set baseURL
axios.defaults.baseURL = '';

// Use current origin + /api - works on ALL domains
const getOriginAPI = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`;
  }
  return '/api';
};

export const API = getOriginAPI();
export const API_BASE = typeof window !== 'undefined' ? window.location.origin : '';

// Function version for dynamic calls
export const getAPI = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.origin}/api`;
  }
  return '/api';
};

// Global 401 interceptor — auto-logout on expired token
axios.interceptors.response.use(
  response => response,
  error => {
    const authPaths = ['/login', '/logowanie', '/register', '/rejestracja', '/reset-hasla', '/auth/callback'];
    const isAuthPage = authPaths.some(p => window.location.pathname.startsWith(p));
    if (error.response?.status === 401 && !isAuthPage) {
      localStorage.removeItem('token');
      window.location.href = '/logowanie';
    }
    return Promise.reject(error);
  }
);

/**
 * Fetch wrapper that auto-handles 401 (expired token → redirect to login)
 */
export const authFetch = (url, options = {}) => {
  const token = localStorage.getItem('token');
  return fetch(url, {
    ...options,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', ...options.headers },
  }).then(r => {
    const authPaths = ['/login', '/logowanie', '/register', '/rejestracja', '/reset-hasla', '/auth/callback'];
    const isAuthPage = authPaths.some(p => window.location.pathname.startsWith(p));
    if (r.status === 401 && !isAuthPage) {
      localStorage.removeItem('token');
      window.location.href = '/logowanie';
      return new Response('{}', { status: 401 });
    }
    return r;
  });
};

/**
 * Extract error message from API response
 * Handles Pydantic validation errors (array of objects) and string errors
 */
export const getErrorMessage = (error, fallback = 'Wystąpił błąd') => {
  const detail = error?.response?.data?.detail;
  
  if (!detail) return fallback;
  
  if (typeof detail === 'string') {
    return detail;
  }
  
  if (Array.isArray(detail) && detail.length > 0) {
    // Pydantic validation errors
    return detail.map(err => err.msg || err.message || 'Błąd walidacji').join(', ');
  }
  
  if (typeof detail === 'object' && detail.msg) {
    return detail.msg;
  }
  
  return fallback;
};

export default API;
